import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, ItemGroup, Item, Label, Divider } from './Toolbar';
import Heading from '../Heading';
import Text from '../Text';
export var Title = function Title(props) {
  var dataHook = props.dataHook;
  return /*#__PURE__*/React.createElement(Heading, {
    dataHook: dataHook,
    appearance: "H3"
  }, props.children);
};
Title.displayName = 'TableToolbar.Title';
Title.propTypes = {
  children: PropTypes.node,
  dataHook: PropTypes.string
};
export var SelectedCount = function SelectedCount(props) {
  var dataHook = props.dataHook;
  return /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook,
    weight: "normal",
    size: "medium"
  }, props.children);
};
SelectedCount.displayName = 'TableToolbar.SelectedCount';
SelectedCount.propTypes = {
  children: PropTypes.node,
  dataHook: PropTypes.string
};
export var TableToolbar = Toolbar; // Aliases for convenience

TableToolbar.ItemGroup = ItemGroup;
TableToolbar.Item = Item;
TableToolbar.Label = Label;
TableToolbar.SelectedCount = SelectedCount;
TableToolbar.Title = Title;
TableToolbar.Divider = Divider;